import React from 'react';
import './Denied.css';

const Denied = () => {


    return (
        <div className="denied-page">
            <div className="top">
                <img src="/logo.png" alt="Cleanier Snack" className="complete-logo" />
            </div>
            <div className="denied-container">
                <div className="undefined-container">
                    <img src='/undefined.png' alt='undefined' className='undefined-image' />
                    <div className='message'>
                        페이지를 찾을 수 없습니다.
                    </div>
                    <div className='sub-message'>
                        요청하신 페이지를 찾을 수 없습니다.<br />
                        입력한 주소를 다시 한 번 확인해 주시기 바랍니다.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Denied;
